import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const defaultPlansUrls = {
    development: "http://localhost:3456/api/public/pricing/v1/plans",
    production: "https://cms.superwall.com/api/public/pricing/v1/plans"
};
const useSubscriptionPlans = (options)=>{
    const [plans, setPlans] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)([]);
    const [isLoading, setIsLoading] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(true);
    const [error, setError] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(null);
    const plansUrl = options?.plansUrl || defaultPlansUrls[process.env.NODE_ENV];
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (!plansUrl) return void console.error("[CRITICAL] No plans URL found", process.env.NODE_ENV, process.env.NEXT_PUBLIC_CMS_URL);
        const fetchPlans = async ()=>{
            try {
                setIsLoading(true);
                setError(null);
                const response = await fetch(plansUrl);
                if (!response.ok) throw new Error(`Failed to fetch plans: ${response.statusText}`);
                const data = await response.json();
                setPlans(data);
            } catch (err) {
                console.error("[CRITICAL] Failed to fetch pricing plans:", err);
                setError(err instanceof Error ? err : new Error("Unknown error"));
                setPlans([]);
            } finally{
                setIsLoading(false);
            }
        };
        fetchPlans();
    }, [
        plansUrl
    ]);
    return {
        plans,
        isLoading,
        error
    };
};
export { useSubscriptionPlans };
